module.exports = __webpack_public_path__ + "static/media/oberflex-bamboufinnaturel-1200x2490.c6a02a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-bamboufinnaturel-1200x2490.jpg
// module id = 982
// module chunks = 37